import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const AnnouncementBar = ({ text }) => (
    <Box
        component="section"
        role="status"
        aria-live="polite"
        sx={{
            width: '100%',
            bgcolor: '#8a4b00',
            color: 'common.white',
            px: 2,
            py: 0.75,
            textAlign: 'center',
        }}
    >
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {text}
        </Typography>
    </Box>
);

export default AnnouncementBar;
